<template>
    <div style="height: 100%; width: 100%;">
        <div class="custom-container">
            <v-card flat>
                <v-card-title class="headline">
                    Mitarbeiter
                </v-card-title>

                <v-card-text>
                    Eine Übersicht aller Ihnen zugeordneten Mitarbeiter.
                </v-card-text>
            </v-card>

            <v-card class="mt-4">
                <v-card-title>
                    Mitarbeiter, mit denen Sie als Führungskraft dieses
                    Jahr noch kein Gespräch geführt haben.
                    <v-spacer/>
                    <v-btn color="secondary" :to="{ name: 'EmployeeInterviewsCreate'}"><v-icon>mdi-plus</v-icon>Neues Gespräch </v-btn>
                </v-card-title>
                <v-card-title>
                    <v-text-field
                            v-model="searchOverdue"
                            append-icon="mdi-magnify"
                            label="Suchen"
                            single-line
                            hide-details
                    ></v-text-field>

                </v-card-title>
                <EmployeeInterviewsUtilityEmployeesDataTable :headers="headers" :search="searchOverdue" :items="employeesOverdue">
                    <!--Customizing default rows-->
                </EmployeeInterviewsUtilityEmployeesDataTable>
            </v-card>

            <v-card class="mt-8">
                <v-card-title>
                    Mitarbeiter, welche Ihnen zugeordnet sind
                    <v-spacer/>
                    <v-btn color="secondary" :to="{ name: 'EmployeeInterviewsCreate'}"><v-icon>mdi-plus</v-icon>Neues Gespräch </v-btn>
                </v-card-title>
                <v-card-title>
                    <v-text-field
                            v-model="searchAll"
                            append-icon="mdi-magnify"
                            label="Suchen"
                            single-line
                            hide-details
                    ></v-text-field>

                </v-card-title>
                <EmployeeInterviewsUtilityEmployeesDataTable :headers="headers" :search="searchAll" :items="employeesAll" type="employee">
                    <!--Customizing default rows-->
                </EmployeeInterviewsUtilityEmployeesDataTable>
            </v-card>
        </div>
    </div>
</template>

<script>
    export default {
        data: () => ({
            searchOverdue: '',
            searchAll: '',
            headers: [
                {
                    text: 'Letztes Mitarbeitergespräch',
                    value: 'last_interview_at',
                    align: 'start',
                },
                { text: 'Personalnummer', value: 'staff_number'},
                { text: 'Vorname', value: 'first_name'},
                { text: 'Nachname', value: 'last_name'},
                { text: 'E-Mail-Adresse', value: 'email'},
                { text: 'Organisationseinheit', value: 'orga_unit'},
                { value: 'action'},
            ],

            employeesOverdue: [],
            employeesAll: [],
        }),
        created() {
            this.getAll();
            this.getOverdue();

        },
        methods: {
            getAll(){
                this.axios.get('/users?type=employees').then( (response) => {
                    this.employeesAll = Object.values({...response.data.data.users});
                });
            },
            getOverdue(){
                this.axios.get('/users?type=employees-year').then( (response) => {
                    this.employeesOverdue = Object.values({...response.data.data.users});
                });
            }
        }

    }
</script>

<style scoped>

</style>